import PageTemplate from '../containers/common/PageTemplate';

import Container from '../containers/mobile_favorite';

export default function MobileFavorite() {
  return (
    <>
      <PageTemplate type={true}>
        <Container />
      </PageTemplate>
    </>
  );
}
